"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ManualParticle = void 0;

var Utils_1 = require("../../Utils");

var ManualParticle = /*#__PURE__*/function () {
  function ManualParticle() {
    _classCallCheck(this, ManualParticle);
  }

  _createClass(ManualParticle, [{
    key: "load",
    value: function load(data) {
      var _a, _b;

      if (!data) {
        return;
      }

      if (data.position !== undefined) {
        this.position = {
          x: (_a = data.position.x) !== null && _a !== void 0 ? _a : 50,
          y: (_b = data.position.y) !== null && _b !== void 0 ? _b : 50
        };
      }

      if (data.options !== undefined) {
        this.options = Utils_1.Utils.deepExtend({}, data.options);
      }
    }
  }]);

  return ManualParticle;
}();

exports.ManualParticle = ManualParticle;